/**
 * Created by jv on 14/06/2017.
 */
module.exports = {
  DEFAULT_LOCALE: "nl-BE",

  API_DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSZZ",
  READABLE_DATE_FORMAT: "DD-MM-YYYY",

  // 50mb
  // MAX_UPLOAD_FILE_SIZE: 52428800,
  // 100mb
  // MAX_UPLOAD_FILE_SIZE: 104857600,
  // 250mb
  MAX_UPLOAD_FILE_SIZE: 262144000,

  BM_TRANSITION_SPEED: 300,

  MOVEMENTS: {
    HORIZONTAL: "horizontal",
    VERTICAL: "vertical",
    DIAGONAL: "diagonal"
  },

  DIRECTIONS: {
    UP: "up",
    DOWN: "down",
    LEFT: "left",
    RIGHT: "right"
  },

  BUSINESS_MODEL_ACTIONS: {
    ACTIVATE: "activate",
    DEACTIVATE: "deactivate"
  }
};



// WEBPACK FOOTER //
// ./app/js/config/constants.js